<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    window.document.title = this.$store.state.headerTitle
  },
  created () {
    this.$store.commit('setLoginInfo', sessionStorage.getItem('loginInfo') ? JSON.parse(sessionStorage.getItem('loginInfo')) : {})
    this.$store.commit('setBreadcrumb', sessionStorage.getItem('breadcrumbContent') ? JSON.parse(sessionStorage.getItem('breadcrumbContent')) : [])
    this.$store.commit('setUserPrivileges', sessionStorage.getItem('userPrivileges') ? JSON.parse(sessionStorage.getItem('userPrivileges')) : [])
    sessionStorage.clear()
    //   页面刷新时将数据存储到sessionStorage中
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('loginInfo', JSON.stringify(this.$store.state.loginInfo))
      sessionStorage.setItem('breadcrumbContent', JSON.stringify(this.$store.state.breadcrumbContent))
      // 当前页面权限列表
      sessionStorage.setItem('userPrivileges', JSON.stringify(this.$store.state.userPrivileges))
    })
  }
}
</script>

<style>
#app {}
</style>



// WEBPACK FOOTER //
// src/App.vue